import type { Permission, PersonnelTmdPermission } from "src/api/Tmd.dtos";
import type { ILayoutItemContext } from "src/contexts/layouts/LayoutContext";
import hasPermission from "./hasPermission";

const hasAnyPermission = (
    personnelTmdPermissions?: PersonnelTmdPermission[],
    permissions?: Permission[],
    context?: ILayoutItemContext,
) => {
    if (!permissions || permissions.length === 0) {
        return true;
    }

    if (!personnelTmdPermissions || personnelTmdPermissions.length === 0) {
        return false;
    }

    return permissions.some((permission) =>
        hasPermission(
            personnelTmdPermissions,
            permission,
            context?.trialId,
            context?.institutionId,
        ),
    );
};

export default hasAnyPermission;
